import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { withSpacing } from '../../util/spacing.js';
import styled from 'styled-components';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ImageStyled = /*#__PURE__*/styled(withSpacing('img')).withConfig({
  displayName: "Imagestyled__ImageStyled",
  componentId: "sc-zu5jhi-0"
})(function (props) {
  var _props$$css$objectFit;
  var blur = props.$srcBlur ? {
    '&.drone-blur': {
      filter: 'blur(10px)'
    },
    backgroundImage: "url('".concat(encodeURI(props.$srcBlur), "')"),
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: (_props$$css$objectFit = props.$css.objectFit) !== null && _props$$css$objectFit !== void 0 ? _props$$css$objectFit : '100%',
    transition: 'filter 0.3s ease-in-out',
    color: 'transparent'
  } : undefined;
  return _objectSpread(_objectSpread(_objectSpread({}, props.$css), props.$q), blur);
});

export { ImageStyled };
//# sourceMappingURL=Image.styled.js.map
